import { initApolloClient } from "@/lib/apolloClient";
import {
  GET_LISTING,
  GET_LISTING_EXTENDED_DETAILS,
  GET_LISTING_FULL_DETAILS,
} from "@/graphql/queries/listing";
import { InitialResolver } from "@/lib/use.middlewares";
import { redirect } from "@/lib/serverOnly";
import React, { useEffect } from "react";
import { usePath } from "@/contexts/path/path";
import { Skeleton } from "@aqar-app/react-ui";
import css from "./css.module.scss";
import AppLayout from "@/containers/layouts/AppLayout";
import { Filters } from "@/components/filters/filters";
import { CategoryList } from "@/components/new-resolver/CountersButtons";
import { useLazyQuery, useQuery } from "@apollo/client";
import { useRouter } from "next/router";
import { useAuthState } from "@/contexts/auth/auth.provider";
import { getUnitUrl } from "@/containers/project-screen/ProjectCard";
import { GET_OWNER_LISTINGS } from "@/graphql/queries/user";

function AdRoute() {
  const { updateContext, myListing } = usePath();
  const router = useRouter();
  const { user, token } = useAuthState();

  const [fetchExtended] = useLazyQuery(GET_LISTING_EXTENDED_DETAILS, {
    fetchPolicy: "network-only",
    variables: {
      id: router.query.id,
    },
  });
  const [getFullDetails] = useLazyQuery(GET_LISTING_FULL_DETAILS, {
    fetchPolicy: "network-only",
    variables: {
      id: router.query.id,
    },
    context: { token },
  });
  const [getOwnerListing] = useLazyQuery(GET_OWNER_LISTINGS, {
    fetchPolicy: "network-only",
    variables: {
      listing_id: router.query.id,
    },
    context: { token },
  });
  useQuery(GET_LISTING, {
    variables: { id: router.query.id },
    fetchPolicy: router.query.refetch === "true" ? "network-only" : undefined,
    onCompleted: async (data) => {
      let listing;
      let l = undefined;
      if (router.query.refetch) {
        l = (await fetchExtended()).data.Listing.getListingExtendedDetails;
      }

      try {
        listing = {
          ...data?.Web?.listing,
          extended_details: l,
          __router__: {
            replace: true,
            searchParams: location.search,
          },
        };

        if (
          myListing.user_id === user?.user_id &&
          listing.user_id !== user?.user_id
        ) {
          listing.user = user;
          listing.user_id = user.user_id;
        }

        if (listing.user_id === user?.user_id) {
          if (!listing.user) listing.user = user;

          if (router.query.refetch === "true") {
            const [{ data: fullData }, { data: ownerData }] = await Promise.all([
              getFullDetails(),
              getOwnerListing(),
            ]);
            const {
              new_listing_space_fees,
              active_monthly_listing_space_info,
              ...full
            } = {
              ...fullData?.Listing?.getFullDetails,
            };
            listing = {
              ...listing,
              ...ownerData?.Listing?.getMyListings?.listings?.[0],
              full: {
                new_listing_space_fees,
                active_monthly_listing_space_info,
              },
              ...full,
              ...(fullData?.Listing?.getMyListings?.listings?.[0] || {}),
            };
          }
        }
      } catch (err) {
        console.log('caught error: ', err);
      }
      updateContext({
        listing,
      });
    },
    onError: () => {
      if (myListing) router.replace(`/my-listings/${myListing.id}`);
    },
  });

  return (
    <div className={css.holder}>
      <Skeleton />
      <Skeleton />
      <div className={css.images}>
        <Skeleton />
        <div>
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
        </div>
      </div>
      <div className={css.content}>
        <Skeleton />
        <Skeleton />
        <Skeleton />
        <div>
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
        </div>
      </div>
    </div>
  );
}
AdRoute.getLayout = ({ children }) => (
  <AppLayout>
    <Filters.Layout>
      <>
        <CategoryList />
        {children}
      </>
    </Filters.Layout>
  </AppLayout>
);
AdRoute.getInitialProps = InitialResolver(async (ctx) => {
  const id = parseInt(ctx.query.id, 10);
  const search = ctx?.req?.url.split("?") || [];
  const apolloClient = initApolloClient();
  const { data } = await apolloClient.query({
    query: GET_LISTING,
    variables: { id },
  });
  const { path, daily_rentable, unit_code, ...restOfListing } =
    data?.Web?.listing;
  if (!path) throw "الرجاء مراجعة معلومات الإعلان.";

  // if listing is a project unit redirect to project init
  if (restOfListing?.project_id) {
    const unitPath = getUnitUrl({
      unitId: id,
      unitCode: unit_code,
      ...restOfListing?.project,
    });
    return ctx.redirect(encodeURI(unitPath));
  }

  return redirect(
    encodeURI(
      `${daily_rentable ? "/الحجز-اليومي/" : ""}${path}${
        search[1] ? `?${search[1]}` : ""
      }`,
    ),
    ctx,
  );
});

export default AdRoute;
